import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spin } from "antd";

import {
	getVotingResult,
	getOtherResults,
} from "../../../../store/thunks/get-result";
import QuestionResult from "./question-result";

import "./results.scss";

const Results = ({ voting }) => {
	const dispatch = useDispatch();

	const results = useSelector((store) => store.votingStore.results.results);
	const loading = useSelector((store) => store.votingStore.results.loading);

	const { questions } = useSelector((store) => store.votingStore.voting);
	useEffect(() => {
		dispatch(getVotingResult(voting.id));
	}, [voting.id]);

	useEffect(() => {
		if (results && results.length) {
			dispatch(getOtherResults(results));
		}
	}, [results]);

	return (
		<Spin
			className="loading"
			size="large"
			spinning={loading}
			tip="Загрузка..."
			delay={100}
		>
			{results?.length > 0 && (
				<div className="results-container">
					{questions.map((question) => {
						return (
							<QuestionResult
								key={question.id}
								question={question}
								results={results}
							/>
						);
					})}
				</div>
			)}
		</Spin>
	);
};

export default Results;
